import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'
import uuidv4 from 'uuid/v4'

const getInitialState = () => {
  return Map({
    unsyncedOrders: Map({}),
    orders: Map({}),
    tempOrderPayments: Map({}),
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNORDERS_SET_ORDER:
      return state.setIn(['orders', action.order.uuid], Map(action.order))
    case ActionTypes.VNORDERS_SET_UNSYNCED_ORDER:
      return state.setIn(['unsyncedOrders', action.order.uuid], {})
    case ActionTypes.VNORDERS_UNSET_UNSYNCED_ORDER:
      return state.deleteIn(['unsyncedOrders', action.order.uuid])
    case ActionTypes.VNORDERS_UNSET_ORDER:
      return state.deleteIn(['orders', action.order.uuid])
    case ActionTypes.VNORDERS_SET_TEMP_PAYMENT:
      return state.setIn(['tempOrderPayments', action.orderUuid, uuidv4()], Map(action.payment))
    default:
      return state
  }
}

export default reducer
